import * as pageTypes from './pageTypes'

// TODO find a better way to do this
export const FSM = pageTypes.FSM_PAGE;
export const PDA = pageTypes.PDA_PAGE;
export const TM = pageTypes.TM_PAGE;


// WEBPACK FOOTER //
// ./src/constants/automatonTypes.js